import { gql } from '@apollo/client';

export const OPEN_DATA_PAGE_QUERY = gql`
  query openDataQuery {
    openData: sanityOpenData {
      title
      description
      licence
      showcaseDescription
      showcases {
        _key
        title
        description
        image {
          url
        }
        url
      }
      realtimeTitle
      realtimeDescription
      historicalTitle
      historicalDescription
      appIntegrationTitle
      appIntegrationDescription
    }
    system {
      id
      GBFS
      publicTripHistory
      openDate
      appDeepLinkingPrefix
      publicDomain
    }
  }
`;
